class CM_Gallery {
        
    constructor(){

        var $class      = this;

        setInterval(function(){
            $(".gallery-images-buttons .blue-arrow").removeAttr("hidden");
        }, 100);

        $(document).on('click', ".gallery-year", function(){

            $class.show_loading();

            $.ajax({
                type        : "POST",
                url         : cm_main_data.ajax_url,
                dataType    : 'json',
                data: {
                    action          : 'cm_gallery',
                    year            : $(this).data('year')
                },
                success: function(data){
                    $class.update_gallery(data);
                },
            
                error: function( error ) {
                    console.log(error);
                }
            });
    
        });

        $(document).on('click', ".galleries-year", function () {

            $class.show_loading();

            $.ajax({
                type: "POST",
                url: cm_main_data.ajax_url,
                dataType: 'json',
                data: {
                    action: 'cm_galleries',
                    year: $(this).data('year')
                },
                success: function (data) {
                    console.log(data)
                    $class.update_galleries(data);
                },

                error: function (error) {
                    console.log(error);
                }
            });

        });
    
        $(document).on('change', ".gallery-date-selector", function(){
    
            $class.show_loading();

            $.ajax({
                type        : "POST",
                url         : cm_main_data.ajax_url,
                dataType    : 'json',
                data: {
                    action          : 'cm_gallery',
                    day             : $(this).find("option:selected").data('day')
                },
                success: function(data){
                    $class.update_gallery(data);
                },
            
                error: function( error ) {
                    console.log(error);
                }
            });
    
        });

    }

    show_loading(){
        $(".gallery-container, .gallery-date-selector, .gallery-years").css('opacity', 0.5);
    }

    hide_loading(){
        $(".gallery-container, .gallery-date-selector, .gallery-years").css('opacity', 1);
    }

    update_galleries(data) {
        let $class = this;

        $('.gallery-container').empty();

        /* Cancello le anteprime UIKit */
        UIkit.lightbox(".gallery-images");
        
        if(data.html)
            $('.gallery-container').append(data.html);

        $class.hide_loading();
    }

    update_gallery(data){

        let $class  = this;
        
        $(".gallery-images").remove();
        $(".gallery-images-buttons").before('<ul class="gallery-images bbbb uk-slider-items uk-grid" uk-lightbox="animation: slide"></ul>');

        /* Cancello le anteprime UIKit */
        UIkit.lightbox(".gallery-images");

        $.each(data.images_by_day, function(index, image){
            $(".gallery-images").append(
                '<li data-date="' + data.last_date + '" class="gallery-image-wrapper uk-width-auto uk-flex uk-flex-middle">' + 
                    '<a class="uk-inline" href="' + image.original + '" data-caption="">' + 
                        '<img src="' + image.medium + '">' +
                    '</a>' +
                '</li>');
        });
        
        $.each($(".gallery-images .gallery-image-wrapper"), function(index, el){

            if($(el).data('date') != data.last_date){
                $(el).remove();
            }

        });

        /* Aggiorno le date all'interno del selettore */
        if(data.days_by_year != null){

            $(".gallery-date-selector option").remove();

            $.each(data.days_by_year, function(date, day_data){
                $(".gallery-date-selector").append('<option data-day="' + date + '">' + day_data.full_locale + '</option>');
            });

        }

        $(".gallery-date .day").html(data.curr_day);
        $(".gallery-date .month").html(data.curr_short_month);

        $(".gallery-download-button").attr('href', '?download-gallery=' + data.last_date);

        $class.hide_loading();
    }
}

jQuery(document).ready(function($){
    new CM_Gallery();
});

